import { ContainerSection } from "@/main/components/shared/styles";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0px 0px 2rem;

	> h2 {
		font-weight: bold;
	}
	.kog-area-textToCopy {
		max-width: 1000px;
		align-items: center;
	}
`;

export const HeaderText = styled.p`
	color: #9f9f9f;
	font-size: 1rem;
	font-weight: bold;
`;

export const HeaderTextSession = styled.p`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin-bottom: 1rem;
	margin-right: 1rem;
`;

export const RowInputs = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	margin-bottom: 16px;

	@media (max-width: 1200px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;
export const ContainerScroll = styled(ContainerSection)`
	max-height: 390px;
	overflow-y: auto;
	margin-bottom: 0px;
`;

export const ContainerTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
`;

export const IconClose = styled(CloseIcon)`
	&&& {
		cursor: pointer;
	}
`;

interface IContainerProps {
	$isDragging: boolean;
}

export const ContainerArea = styled.div<IContainerProps>`
	border: ${({ theme }) => `2px dashed ${theme.pantone2726C}`};
	background: ${({ $isDragging, theme }) => ($isDragging ? theme.pantone642C : theme.white)};
	border-radius: 5px;
	padding: 20px;
	transition: all 0.2s;
	cursor: pointer;
	display: flex;
	align-items: center;

	> p {
		margin: 0;
		margin-right: 2rem;
	}

	.actions {
		display: flex;
		align-items: center;
		gap: 8px;
	}
`;

export const ContainerFile = styled.div`
	margin: 20px 0;
`;

export const PDFContainer = styled.div`
	height: 70dvh;
	overflow: auto;
`;

export const FooterContentPreviewModal = styled.div`
	display: flex;
	justify-content: center;
	padding: 10px 0;
	margin-top: 20px;

	span {
		text-decoration: underline;
		cursor: not-allowed;
		color: #808080;
	}
`;

export const Checkboxes = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
`;
